import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    MAT_MOMENT_DATE_ADAPTER_OPTIONS,
    MAT_MOMENT_DATE_FORMATS,
    MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AumicoComponentsModule } from '@modeso/aumico-components';
import { AumicoCoreModule } from '@modeso/aumico-lib-core-fe';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { I18NextModule, I18NextService } from 'angular-i18next';
import { PersonProjectOverviewTableComponent } from './components/person-project-overview-table/person-project-overview-table.component';
import { ProjectOverviewTableComponent } from './components/project-overview-table.component';
import { PersonProjectsEffects } from './effects/person-projects.effects';
import { projectsOverviewEffects } from './effects/projects-overview.effects';
import { ProjectsConfig, ProjectsConfigService } from './projects.config';
import { personProjectsFeature } from './reducers/person-projects.reducer';
import { projectsOverviewFeature } from './reducers/projects-overview.reducer';
import { PersonProjectsService } from './services/person-projects.service';
import { ProjectsService } from './services/projects.service';

export function matDateLocaleFactory(i18nextService: I18NextService): string {
    return i18nextService.language;
}

const EXPORTED_DECLARATIONS = [ProjectOverviewTableComponent, PersonProjectOverviewTableComponent];

const ANGULAR_MATERIAL = [MatDatepickerModule, MatFormFieldModule];

@NgModule({
    declarations: EXPORTED_DECLARATIONS,
    imports: [
        CommonModule,
        I18NextModule,
        AumicoComponentsModule,
        FormsModule,
        ReactiveFormsModule,
        ANGULAR_MATERIAL,
        EffectsModule.forFeature([projectsOverviewEffects, PersonProjectsEffects]),
        StoreModule.forFeature(projectsOverviewFeature),
        StoreModule.forFeature(personProjectsFeature),
        AumicoComponentsModule,
        AumicoCoreModule,
        FormsModule,
        ReactiveFormsModule,
        DragDropModule,
        ANGULAR_MATERIAL,
    ],
    exports: EXPORTED_DECLARATIONS,
    providers: [
        ProjectsService,
        PersonProjectsService,
        { provide: MAT_DATE_LOCALE, useFactory: matDateLocaleFactory, deps: [I18NextService] },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    ],
})
export class AumicoProjectsModule {
    static forRoot(config: ProjectsConfig): ModuleWithProviders<AumicoProjectsModule> {
        return {
            ngModule: AumicoProjectsModule,
            providers: [
                ProjectsService,
                {
                    provide: ProjectsConfigService,
                    useValue: config,
                },
            ],
        };
    }
}
